import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ChecklistStepId = 'venue' | 'strategy' | 'backtest' | 'bot' | 'team';

interface ChecklistState {
  /** Set of step ids the user explicitly skipped. */
  skipped: ChecklistStepId[];
  /** UI override that hides the rail entirely; survives reload. */
  archived: boolean;
  skip: (id: ChecklistStepId) => void;
  unskip: (id: ChecklistStepId) => void;
  archive: () => void;
  unarchive: () => void;
}

export const useChecklistStore = create<ChecklistState>()(
  persist(
    (set, get) => ({
      skipped: [],
      archived: false,
      skip: (id) => {
        if (get().skipped.includes(id)) return;
        set({ skipped: [...get().skipped, id] });
      },
      unskip: (id) => set({ skipped: get().skipped.filter((s) => s !== id) }),
      archive: () => set({ archived: true }),
      unarchive: () => set({ archived: false }),
    }),
    {
      name: 'loki:onboarding-checklist',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ skipped: s.skipped, archived: s.archived }),
    },
  ),
);
